// @flow

import {
  WS_CONNECT,
  WS_DISCONNECT,
  WS_CONNECT_SUCCESS,
  WS_CONNECT_ERROR,
  WS_CONNECT_DEPOSIT,
  WS_DISCONNECT_DEPOSIT,
  WS_CONNECT_DEPOSIT_SUCCESS,
  WS_CALL_PENDING,
  WS_CLEAR_PENDING,
  WS_DISPLAY_ERROR_LAYER,
  WS_READY,
} from '../actions';
import type { WebsocketState, WebsocketActions } from '../types';

export const initialState: WebsocketState = {
  connecting: false,
  connected: false,
  connectingDeposit: false,
  connectedDeposit: false,
  ready: null,
  pendingCall: false,
  layerError: null,
  backgroundAPI: false,
  loading: false,
};

export const websocketReducer = (state: WebsocketState = initialState, action: WebsocketActions): WebsocketState => {
  switch (action.type) {
    case WS_CONNECT:
      return {
        ...state,
        connecting: true,
        connected: false,
      };

    case WS_DISCONNECT:
      return {
        ...state,
        connecting: false,
        connected: false,
      };

    case WS_CONNECT_SUCCESS:
      return {
        ...state,
        connecting: false,
        connected: true,
      };

    case WS_CONNECT_ERROR:
      return {
        ...state,
        connecting: false,
        connected: false,
      };

    case WS_CONNECT_DEPOSIT:
      return {
        ...state,
        connectingDeposit: true,
        connectedDeposit: false,
      };

    case WS_DISCONNECT_DEPOSIT:
      return {
        ...state,
        connectingDeposit: false,
        connectedDeposit: false,
      };

    case WS_CONNECT_DEPOSIT_SUCCESS:
      return {
        ...state,
        connectingDeposit: false,
        connectedDeposit: true,
      };

    case WS_READY:
      return {
        ...state,
        ready: action.payload,
      };

    case WS_CALL_PENDING:
      return {
        ...state,
        pendingCall: true,
      };

    case WS_CLEAR_PENDING:
      return {
        ...state,
        pendingCall: false,
        layerError: null,
        backgroundAPI: false,
      };

    case WS_DISPLAY_ERROR_LAYER:
      return {
        ...state,
        layerError: action.payload,
      };

    default:
      return state;
  }
};
